import { Timestamp as AdminTimestamp } from "firebase-admin/firestore";
import { Timestamp } from "firebase/firestore";

export type NewgenusTimestamp = AdminTimestamp | Timestamp;